import { manhwaList } from '@/mocks/manhwa';
import ManhwaCard from '@/components/feature/ManhwaCard';

export default function Gems() {
  const gems = manhwaList.filter((m) => m.hiddenGem);

  return (
    <section id="gems" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-secondary-600">
              <i className="ri-vip-diamond-line" /> 挖宝专区
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">冷门宝藏韩漫</h2>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600">
              人气榜单之外的遗珠，好看却相对冷门，适合想挖宝的老读者。每一部都是编辑私藏的惊喜。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-4 py-2 text-sm text-secondary-900">
            <i className="ri-sparkling-line" /> 编辑私藏 {gems.length} 部
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
          {gems.map((item) => (
            <ManhwaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}